const BASE_URL = 'https://backend-final-project-technigo-ognztdcbaq-no.a.run.app'

export const API_URL = (slug) => `${BASE_URL}/${slug}`